import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { Alert, Button, Field, Input, Spinner } from "../components/ui";
import { useAuth } from "../lib/auth";

/* Landing page for the reset link: /gear/reset-password?email=&token= */
export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { resetPassword } = useAuth();

  const email = params.get("email") || "";
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Those passwords don't match.");
      return;
    }
    setBusy(true);
    try {
      await resetPassword({ email, token, password });
      navigate("/gear");
    } catch (err) {
      setError(err.message || "Couldn't reset your password.");
    } finally {
      setBusy(false);
    }
  }

  if (!email || !token) {
    return (
      <AuthLayout title="That link looks incomplete">
        <Alert>
          This reset link is missing part of its address. Open it from your email exactly as
          it was sent, or request a new one.
        </Alert>
        <p className="mt-4 text-sm text-slate-500">
          <Link to="/gear/forgot-password" className="font-semibold text-brand-600">
            Request a new reset link
          </Link>
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Set a new password">
      <p className="text-sm text-slate-500">
        For <span className="font-medium text-slate-700">{email}</span>.
      </p>
      <form onSubmit={submit} className="mt-4 space-y-3">
        <Field label="New password" hint="At least 8 characters">
          <Input
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </Field>
        <Field label="Confirm new password">
          <Input
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="••••••••"
          />
        </Field>
        <Alert>{error}</Alert>
        <Button type="submit" disabled={busy} className="w-full">
          {busy ? <Spinner /> : "Set new password"}
        </Button>
      </form>
      <p className="mt-4 text-sm text-slate-500">
        Link expired?{" "}
        <Link to="/gear/forgot-password" className="font-semibold text-brand-600">
          Request a new one
        </Link>
      </p>
    </AuthLayout>
  );
}
